<template>
  <h1>
    <nuxt-link to="/" class="flex items-center gap-3.5">
      <sps-img v-if="image?.src" :image="image" />
      <p v-else class="text-wrap-global text-32px color-primary font-600">
        {{ datas?.shop?.name }}
      </p>
    </nuxt-link>
  </h1>
</template>

<script lang="ts" setup>
// const props = defineProps<{
//   datas: any
// }>()

const datas = inject<any>('headersDatas')

const isMob = useIsMobile()

const image = computed(() => {
  if (isMob.value) {
    return datas.value?.settings?.header?.settings?.mob_image
  }
  return datas.value?.settings?.header?.settings?.pc_image
})
</script>

<style lang="scss" scoped></style>
